import React from 'react';

export function MinusIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="20"
        y="11"
        width="2"
        height="16"
        rx="1"
        transform="rotate(90 20 11)"
        fill="#7B7C88"
      />
    </svg>
  );
}
